/* ==========================================================================
   AutocompleteRxjs > Client > Store > Actions
   ========================================================================== */

/* Types */

const CHANGE_VALUE = 'AUTOCOMPLETE::CHANGE_VALUE';
const CLEAR = 'AUTOCOMPLETE::CLEAR';
const CLOSE_SUGGESTIONS = 'AUTOCOMPLETE::CLOSE_SUGGESTIONS';
const DESTROY = 'AUTOCOMPLETE::DESTROY';
const DISABLE = 'AUTOCOMPLETE::DISABLE';
const DISPLAY = 'AUTOCOMPLETE::DISPLAY';
const ENABLE = 'AUTOCOMPLETE::ENABLE';
const HIDE = 'AUTOCOMPLETE::HIDE';
const OPEN_SUGGESTIONS = 'AUTOCOMPLETE::OPEN_SUGGESTIONS';
const RESET_STATUS = 'AUTOCOMPLETE::RESET_STATUS';
const SET_UI_STATE = 'AUTOCOMPLETE::SET_UI_STATE';
const SET_ERROR = 'AUTOCOMPLETE::SET_ERROR';
const SET_QUERY = 'AUTOCOMPLETE::SET_QUERY';
const SET_SUGGESTIONS = 'AUTOCOMPLETE::SET_SUGGESTIONS';
const SET_VALID = 'AUTOCOMPLETE::SET_VALID';
const SET_VALUE = 'AUTOCOMPLETE::SET_VALUE';
const SYNC_VALUE = 'AUTOCOMPLETE::SYNC_VALUE';
const TOGGLE_ACTIVE = 'AUTOCOMPLETE::TOGGLE_ACTIVE';
const TOGGLE_LOADING = 'AUTOCOMPLETE::TOGGLE_LOADING';

/* Actions */

const changeValue = payload => ({ type: CHANGE_VALUE, payload });
const clear = () => ({ type: CLEAR });
const closeSuggestions = () => ({ type: CLOSE_SUGGESTIONS });
const destroy = () => ({ type: DESTROY });
const disable = () => ({ type: DISABLE });
const display = () => ({ type: DISPLAY });
const enable = () => ({ type: ENABLE });
const hide = () => ({ type: HIDE });
const openSuggestions = payload => ({ type: OPEN_SUGGESTIONS, payload });
const resetStatus = () => ({ type: RESET_STATUS });
const setUiState = payload => ({ type: SET_UI_STATE, payload });
const setError = () => ({ type: SET_ERROR });
const setQuery = payload => ({ type: SET_QUERY, payload });
const setSuggestions = payload => ({ type: SET_SUGGESTIONS, payload });
const setValid = () => ({ type: SET_VALID });
const setValue = payload => ({ type: SET_VALUE, payload });
const syncValue = () => ({ type: SYNC_VALUE });
const toggleActive = () => ({ type: TOGGLE_ACTIVE });
const toggleLoading = () => ({ type: TOGGLE_LOADING });

/* Exports */
module.exports = {
    types: {
        CHANGE_VALUE,
        CLEAR,
        CLOSE_SUGGESTIONS,
        DESTROY,
        DISABLE,
        DISPLAY,
        ENABLE,
        HIDE,
        OPEN_SUGGESTIONS,
        RESET_STATUS,
        SET_UI_STATE,
        SET_ERROR,
        SET_QUERY,
        SET_SUGGESTIONS,
        SET_VALID,
        SET_VALUE,
        SYNC_VALUE,
        TOGGLE_ACTIVE,
        TOGGLE_LOADING
    },
    actions: {
        changeValue,
        clear,
        closeSuggestions,
        destroy,
        disable,
        display,
        enable,
        hide,
        openSuggestions,
        resetStatus,
        setUiState,
        setError,
        setQuery,
        setSuggestions,
        setValid,
        setValue,
        syncValue,
        toggleActive,
        toggleLoading
    }
};
